var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63112 3.13333H15.1548C16.3797 3.13333 17.2641 4.26222 16.9281 5.39822L15.4579 10.376C15.2312 11.1404 14.5077 11.6667 13.6846 11.6667H5.54404C4.72003 11.6667 3.99558 11.1396 3.7698 10.376L1.63112 3.13333ZM1.63112 3.13333L1 1M13.0001 17C13.3537 17 13.6929 16.8595 13.9429 16.6095C14.193 16.3594 14.3334 16.0203 14.3334 15.6667C14.3334 15.313 14.193 14.9739 13.9429 14.7239C13.6929 14.4738 13.3537 14.3333 13.0001 14.3333C12.6465 14.3333 12.3073 14.4738 12.0573 14.7239C11.8072 14.9739 11.6668 15.313 11.6668 15.6667C11.6668 16.0203 11.8072 16.3594 12.0573 16.6095C12.3073 16.8595 12.6465 17 13.0001 17ZM5.88893 17C6.24256 17 6.5817 16.8595 6.83175 16.6095C7.0818 16.3594 7.22227 16.0203 7.22227 15.6667C7.22227 15.313 7.0818 14.9739 6.83175 14.7239C6.5817 14.4738 6.24256 14.3333 5.88893 14.3333C5.53531 14.3333 5.19616 14.4738 4.94611 14.7239C4.69606 14.9739 4.55559 15.313 4.55559 15.6667C4.55559 16.0203 4.69606 16.3594 4.94611 16.6095C5.19616 16.8595 5.53531 17 5.88893 17Z",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/Purchase.3a4f0cb2e91d0a706e9ec62610666176.svg";
export { ForwardRef as ReactComponent };